import React, { forwardRef } from "react";
import { Button, Typography } from '../../components/Wrappers'
import { Grid} from "@material-ui/core";
// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import Workload from '../../components/Reports/Workload.js';
import Overdue from '../../components/Reports/Overdue.js';
import RefundSubmission from '../../components/Reports/RefundSubmission.js';
import RefundSummary from '../../components/Reports/RefundSummary.js';
import Operational from '../../components/Reports/Operational.js';
import Finance from '../../components/Reports/Finance.js';
import MissingWork from '../../components/Reports/MissingWork.js';
import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";

const Reports = forwardRef((props, ref) => {
    var classes = useStyles();
    const adminRoles = JSON.parse(localStorage.getItem("admin_roles"));
    const refundRole = adminRoles?.includes("REFUND");
    const financeRole = adminRoles?.includes("FINANCE_SUMMARY");
    const masterRole = adminRoles?.includes("MASTER_SUMMARY");

    const openOldReportsPage = () => {
        window.open(`${config.clientApi}`,'_blank');
    }
    return (
      <>
        <PageTitle title="Reports" />
        <Grid container spacing={8}>
          <Grid item xs={12} md={6} lg={4}>
            <Widget title="Scheduling/Booking" disableWidgetMenu showOverflow>

              <div className={classes.layoutContainer}>
              <Typography className={classes.reportSubtitle}>
                Workload Report:
              </Typography>

                <Workload/>
              </div>

              <div className={classes.layoutContainer}>
              <Typography className={classes.reportSubtitle}>
                Overdue Report:
              </Typography>

                <Overdue/>
              </div>

              <div className={classes.layoutContainer}>
                <Typography className={classes.reportSubtitle}>
                  Same Month Jobs Comparison Report (Last Year):
                </Typography>

                <MissingWork/>
              </div>
            </Widget>
          </Grid>
          {refundRole && <Grid item xs={12} md={6} lg={4}>
            <Widget title="Refund Reports" disableWidgetMenu showOverflow>
                <div className={classes.layoutContainer}>
                <Typography className={classes.reportSubtitle}>
                  Refund Submission Report:
                </Typography>

                  <RefundSubmission/>
                </div>
                <div className={classes.layoutContainer}>
                <Typography className={classes.reportSubtitle}>
                  Refund Summary Report:
                </Typography>

                  <RefundSummary/>
                </div>
            </Widget>
          </Grid>}
          <Grid item xs={12} md={6} lg={4}>
            <Widget title="Legacy Reports" disableWidgetMenu showOverflow>
              <Typography>

              </Typography>
              <div className={classes.buttonsContainer}>
              <Button onClick={openOldReportsPage} >
                <span>open in new window</span>
              </Button>
              </div>
            </Widget>
          </Grid>
          {!refundRole &&
          <Grid item xs={12} md={6} lg={4}>
            <Widget title="" disableWidgetMenu showOverflow>
              <Typography>

              </Typography>
              <div className={classes.codeContainer}>
                <Typography variant="caption">
                </Typography>
              </div>
            </Widget>
          </Grid>}
          <Grid item xs={12} md={6} lg={4}>
            <Widget title="Operational Reports" disableWidgetMenu showOverflow>
                <div className={classes.layoutContainer}>
                <Typography className={classes.reportSubtitle}>
                  Daily Operational Report:
                </Typography>

                  <Operational/>
                </div>

            </Widget>
          </Grid>
          {financeRole &&
          <Grid item xs={12} md={6} lg={4}>
            <Widget title="Finance Reports" disableWidgetMenu showOverflow>
                <div className={classes.layoutContainer}>
                <Typography className={classes.reportSubtitle}>
                  Finance Report:
                </Typography>

                  <Finance/>
                </div>

            </Widget>
          </Grid>}
          {!financeRole &&
          <Grid item xs={12} md={6} lg={4}>
            <Widget title="" disableWidgetMenu showOverflow>
              <Typography>

              </Typography>
              <div className={classes.codeContainer}>
                <Typography variant="caption">
                </Typography>
              </div>
            </Widget>
          </Grid>}
          <Grid item xs={12} md={6} lg={4}>
            <Widget title="" disableWidgetMenu showOverflow>
            </Widget>
          </Grid>
        </Grid>
      </>
    );
});

export default Reports;
